import React from 'react';
import SectionHeader from '../components/sections/partials/SectionHeader';
import Clients from '../components/sections/Clients';
import HeroSplit from '../components/sections/HeroSplit';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import GenericSection from '../components/sections/GenericSection';
import ButtonGroup from '../components/elements/ButtonGroup';
import Button from '../components/elements/Button';

class Home extends React.Component {
  /* constructor(props) {
    super(props);
    ReactGA.initialize("G-11YBZ4N1WL");
  } */
  render() {
    return (
      <React.Fragment>
        <HeroSplit hasBgColor invertColor />
        <FeaturesTiles />
        <Clients topDivider bottomDivider />
        <GenericSection className="center-content">
          <div className="container">
            <SectionHeader data={{ title: "Contacto" }} className="center-content" />
            <ButtonGroup>
              <Button tag="a" href="mailto:jorgedesigner23@gmail.com" color="dark" wideMobile>
                jorgedesigner23@gmail.com
              </Button>
              <Button tag="a" href="https://www.linkedin.com/in/dcg-jorgemunoz/" color="dark" wideMobile>
                LinkedIn
              </Button>
              <Button tag="a" href="https://www.behance.net/jorgemuoz1" color="dark" wideMobile>
                Behance
              </Button>
            </ButtonGroup>
          </div>
        </GenericSection>
      </React.Fragment>
    );
  }
}

export default Home;